export const DesignSystem = {
  Grid: {
    childExtends: {
      theme: 'common-card-interactive',
      padding: 'Z2 Y2 Z2 Z2',
      align: 'center space-between',
      flex: '1',
      round: 'radiusCard',
      gap: 'B2',
      width: '100%',
      href: '{{ href }}',
      '@tabletL': {
        maxWidth: 'none'
      },
      ':nth-child(2)': {
        '> div > p': {
          maxWidth: 'E3'
        }
      },
      WiderButton: {
        icon: (el, s) => s.icon,
        padding: 'Y2',
        background: (el, s) => s.background,
        theme: (el, s) => s.theme
      },
      Hgroup: {
        gap: 'X2',
        H: {
          text: (el, s) => el.call('polyglot', s.title || ''),
          fontSize: 'A',
          fontWeight: '500'
        },
        P: {
          text: (el, s) => el.call('polyglot', s.p || ''),
          fontSize: 'Z',
          maxWidth: (el, s) => s.maxWidth,
          '@tabletL': {
            maxWidth: 'E3+A1'
          }
        }
      }
    },
    children: () => [
      {
        title: 'editor.panel.colors',
        href: '/docs/color',
        p: 'editor.dsCard.colors',
        icon: 'color',
        theme: 'theme',
        maxWidth: 'E'
      },
      {
        title: 'editor.panel.typography',
        href: '/docs/typography',
        p: 'editor.dsCard.typography',
        icon: 'typography',
        theme: 'typography',
        maxWidth: 'E'
      },
      {
        title: 'editor.panel.spacing',
        href: '/docs/space',
        p: 'editor.dsCard.spacing',
        maxWidth: 'E2',
        icon: 'space',
        theme: 'space'
      },
      {
        title: 'editor.panel.shapes',
        href: '/docs/shapes',
        p: 'editor.dsCard.shapes',
        icon: 'shape',
        theme: 'shape'
      },
      {
        title: 'editor.panel.icons',
        href: '/docs/icons',
        p: 'editor.dsCard.icons',
        icon: 'icons',
        theme: 'icons'
      },
      {
        title: 'editor.panel.breakpoints',
        href: '/docs/media',
        p: 'editor.dsCard.breakpoints',
        icon: 'deviceMobileOutline'
      },
      {
        title: 'editor.panel.sequence',
        href: '/docs/sequence',
        p: 'editor.dsCard.sequence',
        icon: 'stateColored'
      },
      {
        title: 'editor.panel.timing',
        href: '/docs/timing',
        p: 'editor.dsCard.timing',
        icon: 'clock'
      }
    ]
  }
}
